module.exports = __webpack_public_path__ + "img/ring_y_s_1_1.77b73395.png";